import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from 'react-bootstrap'
import * as request from 'services/request'

class DeleteTenantModal extends React.Component {
  constructor (props) {
    super(props)
    this.handleDelete = this.handleDelete.bind(this)
  }

  async handleDelete () {
    const { id, onClose } = this.props

    try {
      await request.authorized(`/tenants/${id}`, { method: 'DELETE' })
    } catch (e) {
      // istanbul ignore next
      console.error(e)
    }

    onClose()
  }

  render () {
    const { name, show, onClose } = this.props
    return (
      <Modal show={show} onHide={onClose}>
        <Modal.Header>
          <Modal.Title>Delete Tenant</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to delete &quot;{name}&quot;?
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={onClose}>Cancel</Button>
          <Button bsStyle='primary' onClick={this.handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

DeleteTenantModal.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  show: PropTypes.bool,
  onClose: PropTypes.func
}

export default DeleteTenantModal



// WEBPACK FOOTER //
// ./src/pages/admin/tenants/delete-modal.js